<template>
  <div class="popup-main">
    <el-dialog
      title="产线管理"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
      @close="popupCancel"
    >
      <div class="m-b-10">
        <!-- 表格操作条 -->
        <vxe-toolbar ref="refToolbar" size="mini" :loading="loading">
          <template #buttons>
            <el-button type="success" size="mini" @click="itemAdd">新增产线</el-button>
          </template>
        </vxe-toolbar>

        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :loading="loading"
          :data="slefList"
          :columns="tableColumn"
          :max-height="this.$util.getViewHeight() - 300"
        >
          <!-- slot_default -->
          <template #default_operate="{ row }">
            <el-link type="primary" @click="itemEdit(row)">编辑</el-link>
            <el-link type="danger" @click="itemDelete(row)">删除</el-link>
          </template>
        </vxe-grid>
      </div>
    </el-dialog>

    <!-- 弹窗-增改产线 -->
    <PopupChanxianDo
      v-if="isShowPopupChanxianDo"
      :show.sync="isShowPopupChanxianDo"
      :data.sync="itemObj"
      @success="getListData"
    />
  </div>
</template>

<script>
import PopupChanxianDo from './popup-chanxian-do'
export default {
  components: { PopupChanxianDo },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      slefList: [],
      loading: true,

      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          field: 'name',
          title: '产线名称'
        },
        { title: '操作', width: 160, slots: { default: 'default_operate' } }
      ],
      isShowPopupChanxianDo: false,
      itemDefault: {
        id: '',
        name: '',
        type: '产线'
      },
      itemObj: {}
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initItemObj()
    this.getListData()
  },
  methods: {
    // 初始化itemObj
    initItemObj() {
      this.itemObj = this.$util.deepCopy(this.itemDefault)
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/list',
        data: {
          type: '产线',
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.slefList = res.data.list
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 项-新增
    itemAdd() {
      this.isShowPopupChanxianDo = true
      this.initItemObj()
    },
    // 项-编辑
    itemEdit(row) {
      this.isShowPopupChanxianDo = true
      this.itemObj = this.$util.deepCopy(row)
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/columnData/delete',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.status === 200 && res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
